module.exports = __webpack_public_path__ + "img/R12.9b2435cc.svg";